import React from 'react';
import { TextField, Typography } from '@mui/material';
import MagnifyingGlassIcon from 'assets/icons/MagnifyingGlass.svg?react';
import { Stack } from '@mui/system';
import { jbColors } from 'theme/jbColors';

type Props = {
  onChange: (text: string) => void;
  searchValue: string;
  title: string;
};

const localStyles = {
  stack: {
    width: '50%',
    padding: 1,
  },
  adornment: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: jbColors.core.stone[10],
    },
    width: '100%',
    '& .MuiInputBase-root': {
      border: 'none',
      padding: 0,
      display: 'flex',
      color: 'black',
    },
    '& .MuiFormControl-root': {
      color: 'black',
    },
    '& .MuiInputBase-input': {
      border: 'none',
      padding: '8px',
      color: 'black',
    },
    '& .MuiOutlinedInput-input': {
      border: 'none',
      color: 'black',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
      color: 'black',
    },
  },
};

//todo: is the figma background styling correct greenSmoke[10]

export const SimpleSearch = ({ searchValue, onChange, title }: Props) => {
  const onTextFieldChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange(e.target.value);
  };

  return (
    <Stack sx={localStyles.stack} data-testid={'simple-search'}>
      <Typography variant="body1">{title}</Typography>
      <TextField
        value={searchValue}
        onChange={onTextFieldChange}
        sx={localStyles.adornment}
        InputProps={{
          endAdornment: <MagnifyingGlassIcon />,
        }}
      ></TextField>
    </Stack>
  );
};
